import { render } from "./Towers.vue?vue&type=template&id=5655e95e"
import script from "./towers.js?vue&type=script&lang=js&external"
export * from "./towers.js?vue&type=script&lang=js&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__